var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSociable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#F9F7FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4158_34324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 30.0011C50 41.0513 41.0492 50.0022 29.9989 50.0022C18.9487 50.0022 10 41.0492 10 30.0011C10 18.953 18.9508 10 30.0011 10C41.0513 10 50.0022 18.9508 50.0022 30.0011M48.0914 29.9837C48.0914 20.0092 39.9995 11.9173 30.0249 11.9173C20.0504 11.9173 11.9585 20.0092 11.9585 29.9837C11.9585 39.9583 20.0504 48.0502 30.0249 48.0502C39.9995 48.0502 48.0914 39.9583 48.0914 29.9837Z",
    fill: "#1E1E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9909 21.9178C24.3789 21.7855 25.6846 22.7029 26.9078 24.6787C27.1464 25.0669 27.1225 25.4313 26.8167 25.7696C26.7083 25.9019 26.602 25.9844 26.4936 26.0169C25.8581 26.2143 25.4026 26.0993 25.1467 25.6699C24.4028 24.4228 23.6849 23.8025 22.9974 23.8177C22.3034 23.8003 21.592 24.4293 20.8567 25.6851C20.6008 26.1145 20.154 26.2316 19.5099 26.0408C19.4101 26.0082 19.3038 25.9258 19.1867 25.7935C18.8809 25.4552 18.8484 25.0908 19.087 24.7026C20.3015 22.7181 21.5985 21.7942 22.9887 21.9178H22.9909Z",
    fill: "#1E1E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0813 21.9175C38.5778 21.8091 39.916 22.8935 41.1067 25.1664C41.3041 25.546 41.0416 26.0101 40.5862 26.0839L40.2804 26.1338C39.6926 26.2248 39.2393 25.9776 38.9335 25.3725C38.4304 24.3727 37.8014 23.8521 37.0575 23.8261C36.3136 23.8348 35.6694 24.3293 35.1402 25.3226C34.8171 25.9169 34.3638 26.1576 33.776 26.0492L33.4702 25.9906C33.0147 25.9082 32.7588 25.4376 32.9735 25.0645C34.2141 22.8241 35.5848 21.7744 37.0813 21.9154V21.9175Z",
    fill: "#1E1E1D"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4158_34324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.0003 37.2685C38.0123 39.8607 35.9116 41.9674 33.3157 41.976L26.7193 41.9983C24.1269 42.0069 22.0141 39.9173 22.002 37.3251V36.7298C21.9883 34.1376 24.0891 32.0309 26.6849 32.0223L33.2813 32C35.8737 31.9932 37.9865 34.081 37.9986 36.6749V37.2702M29.9994 35.987C31.9094 35.999 33.197 36.9683 33.8623 38.8931C34.1993 39.8676 34.636 39.919 35.1809 39.039C35.4732 38.5706 35.6193 38.3304 35.6245 38.3236C36.1058 37.368 36.1264 36.4811 35.6812 35.6645C34.5775 33.6144 32.389 33.9866 29.9977 33.9866C27.6064 33.9866 25.4248 33.6075 24.3143 35.6576C23.8707 36.4742 23.8896 37.3611 24.371 38.3167C24.3779 38.3287 24.524 38.5638 24.8145 39.0321C25.3595 39.9122 25.7979 39.8607 26.1331 38.8863C26.7984 36.9683 28.086 35.999 29.996 35.987M28.1479 40.0443L31.8389 40.0065C31.9025 40.0065 31.9524 39.9551 31.9524 39.8933V39.8624C31.9455 38.8314 31.0894 38.001 30.0424 38.0148H29.9152C28.8614 38.0268 28.0242 38.8691 28.031 39.9019V39.9328C28.031 39.9962 28.0826 40.046 28.1445 40.046L28.1479 40.0443Z",
    fill: "#1E1E1D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4158_34324"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(10 10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4158_34324"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 10,
    fill: "white",
    transform: "translate(22 32)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSociable);
export default __webpack_public_path__ + "static/media/sociable.2fc47a3cd99678bf58a26699cda1941a.svg";
export { ForwardRef as ReactComponent };